import React from 'react';
import { Box, Typography } from '@leap4/frontend';
import { SelectableChip } from './SelectableChip';
import { REPORT_DIMENSIONS } from '../report.constants';

interface DimensionsSelectorProps {
  selectedDimensions: string[];
  onToggle: (dimension: string) => void;
}

export const DimensionsSelector: React.FC<DimensionsSelectorProps> = ({ selectedDimensions, onToggle }) => {
  const supplyDimensions = REPORT_DIMENSIONS.filter((d) => d.group === 'supply');
  const demandDimensions = REPORT_DIMENSIONS.filter((d) => d.group === 'demand');
  const commonDimensions = REPORT_DIMENSIONS.filter((d) => d.group === 'common');

  const renderGroup = (label: string, dimensions: typeof REPORT_DIMENSIONS) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
      <Typography
        sx={{ fontSize: 12, color: 'text.secondary', minWidth: 50, fontWeight: 500 }}
      >
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {dimensions.map((dim) => (
          <SelectableChip
            key={dim.key}
            label={dim.label}
            selected={selectedDimensions.includes(dim.key)}
            onClick={() => onToggle(dim.key)}
          />
        ))}
      </Box>
    </Box>
  );

  return (
    <Box>
      {renderGroup('Supply', supplyDimensions)}
      {renderGroup('Demand', demandDimensions)}
      {renderGroup('Common', commonDimensions)}
    </Box>
  );
};
